var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"ir-base-app",attrs:{"id":"app"}},[(_vm.finishedLoading || _vm.backOfficeCheck)?_c('Main'):_c('MainSkeleton'),_c('SmokeBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }